module.exports = __webpack_public_path__ + "static/media/cancel.8dfa3a32.svg";